import { Injectable } from '@angular/core';
import { Order, PlantPatchRequest, PlantsService } from '@cemex-core/cmx-api';
import { PlantPatchResponse } from '@cemex-core/cmx-api/models/order-management/plants-patch-response';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  OneClickLoadOwnFreightPlantsAction,
  OneClickLoadOwnFreightPlantsCompleteAction,
  OneClickOwnFreightPlantsActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-ownFreight-plants.actions';
import { debounceTime, filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export class OneClickOwnFreightPlantsEffects {
  getOwnFreightPlants = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickOwnFreightPlantsActionTypes.LOAD_OWNFREIGHT_PLANTS),
      debounceTime(1250), // Waiting when the user is typing quantity
      map((action: OneClickLoadOwnFreightPlantsAction) => action.payload),
      filter((order) => !!order),
      map((order) => this.makePlantsPatchRequestFromState(order)),
      switchMap((request: PlantPatchRequest) =>
        this.plantService.patchPlant(request).pipe(
          map((response: PlantPatchResponse) => {
            return new OneClickLoadOwnFreightPlantsCompleteAction(response.items[0].plants);
          }),
        ),
      ),
    ),
  );

  private makePlantsPatchRequestFromState(order: Order): PlantPatchRequest {
    return {
      customer: {
        customerId: order.customer.customerId,
      },
      jobsite: {
        jobsiteId: order.jobsite.jobsiteId,
      },
      shippingCondition: {
        shippingConditionid: order.shippingCondition.shippingConditionId,
        shippingConditionCode: order.shippingCondition.shippingConditionCode,
      },
      salesArea: {
        salesAreaId: order.salesArea.salesAreaId,
      },
      items: [
        {
          quantity: order.items[0].quantity,
          product: {
            productId: order.items[0].product.productId,
          },
          uom: {
            unitId: order.items[0].uom.unitId,
          },
        },
      ],
    } as PlantPatchRequest;
  }

  constructor(
    private actions$: Actions,
    private plantService: PlantsService,
  ) {}
}
